import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/internal/Subject';

@Injectable({
  providedIn: 'root'
})
export class HeaderBreadcrumbService {

  routesListener = new Subject<any>();

  constructor() { }

  public listen() {
    return this.routesListener.asObservable();
  }

  public setRoutes(routes) {
    this.routesListener.next(routes);
  }
}
